/**
 * join-steps.ts — a join's four steps in order, each with its words: a Record,
 * so every step has its key and every key is written whole. A key built from
 * the step's name (`login.step.<step>`) named none of them, and showed the
 * step's code in every language.
 */

import type { ConnectionStep } from '../../domains/auth';

export const STEP_WORDS: Record<ConnectionStep, string> = {
  authenticating: 'login.authenticating',
  updatingAccount: 'login.updatingAccount',
  connectingSocket: 'login.connectingSocket',
  joiningMatch: 'login.joiningMatch',
};

/** The steps in the order a join takes them. */
export const STEPS = Object.keys(STEP_WORDS) as ConnectionStep[];
